<script setup lang="ts">
import { useQuasar } from 'quasar';
import { toTitleCase } from '@/functions/toTitleCase';

const $q = useQuasar();

const props = defineProps<{
    filterOptions: { header: string, options: string[] }[]
    selectedFilters: string[]
}>();

const emit = defineEmits<{
    'update:selectedFilters': [filters: string[]]
}>();

// Toggles filter selection state when user clicks anywhere on the checkbox row
const handleRowClick = (status: string) => {
    const currentSet = new Set(props.selectedFilters);

    if (currentSet.has(status)) {
        currentSet.delete(status);
    } else {
        currentSet.add(status);
    }

    emit('update:selectedFilters', Array.from(currentSet));
};
</script>

<template>
    <div
        v-for="item in filterOptions"
        :key="item.header"
        class="column col-fit q-gutter-y-md"
    >
        <div class="column-title q-pl-lg">
            {{ item.header.toUpperCase() }}
        </div>
        <q-list
            class="q-pl-sm"
            :separator="$q.screen.xs"
        >
            <q-item
                v-for="status in item.options"
                :key="status"
                clickable
                @click="handleRowClick(status)"
            >
                <q-item-section avatar>
                    <q-checkbox
                        class="filter-item"
                        dense
                        keep-color
                        :label="toTitleCase(status)"
                        :val="status"
                        :model-value="selectedFilters"
                        @update:model-value="emit('update:selectedFilters', $event)"
                    />
                </q-item-section>
            </q-item>
            <q-separator v-if="$q.screen.xs" />
        </q-list>
    </div>
</template>
